<template>
  <div class="paginator">
    <button
      type="button"
      aria-hidden="true"
      v-if="this.currentPage !== 0 && this.totalPages > 4"
      aria-label="Show Previous Results Page"
      @click="updatePage(currentPage - 1)"
    >
      <ahc-icon
        icon-name="arrow-left-circle"
        icon-name-hover="arrow-left-circle-hover"
        :focus-parent="true"
      >
      </ahc-icon>
    </button>

    <button
      type="button"
      class="paginator__page-number"
      :disabled="this.currentPage === 0"
      :aria-label="`Show Results Page 1`"
      @click="updatePage(0)"
      v-if="this.currentPage + 1 > this.totalPages - 4 && this.totalPages > 4"
    >
      1
    </button>
    <span
      v-if="this.currentPage + 1 > this.totalPages - 4 && this.totalPages > 4"
      >...</span
    >
    <button
      type="button"
      @click="updatePage(pageNumber - 1)"
      :aria-label="`Show Results Page ${pageNumber}`"
      :class="`paginator__page-number ${
        currentPage + 1 === pageNumber ? 'paginator__page-number--active' : ''
      }`"
      :aria-current="currentPage + 1 === pageNumber ? 'page' : false"
      v-for="(pageNumber, index) in this.displayNumbers()"
      v-bind:key="index"
    >
      {{ pageNumber }}
    </button>
    <span v-if="this.currentPage + 1 <= this.totalPages - 4">...</span>
    <button
      type="button"
      :aria-label="`Show Results Page ${this.totalPages}`"
      :class="`paginator__page-number ${
        currentPage + 1 === totalPages ? 'paginator__page-number--active' : ''
      }`"
      @click="updatePage(totalPages - 1)"
      v-if="this.currentPage + 1 <= this.totalPages - 4"
    >
      {{ this.totalPages }}
    </button>
    <button
      type="button"
      aria-label="Show Next Results Page"
      :disabled="currentPage + 1 === totalPages"
      v-if="currentPage + 1 !== totalPages"
      @click="updatePage(currentPage + 1)"
    >
      <ahc-icon
        aria-hidden="true"
        icon-name="arrow-right-circle"
        icon-name-hover="arrow-right-circle-hover"
        :focus-parent="true"
      ></ahc-icon>
    </button>
  </div>
</template>

<script lang="js">
import ahcIcon from "./../icon/icon.vue";

export default  {
  name: 'ahc-paginator',
  components: {ahcIcon},
  methods: {
    displayNumbers () {
      // Creates an array of which page numbers to display based on the current index
      let numbers = [];
      if (this.currentPage + 1 > this.totalPages - 4) {
        for (var i = this.totalPages - 3; i <= this.totalPages; i++) {
          if (i > 0) numbers.push(i);
        }
      } else {
        numbers = Array.from({length: 4}, (_, x) => x + (this.currentPage + 1)).filter((x) => x < this.totalPages && x > 0);
      }
      return numbers;
    }
  },
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    updatePage: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="scss">
@import "paginator";
</style>
